import { createBrowserRouter }                   from 'react-router-dom';
import { RouterProvider as ReactRouterProvider } from 'react-router-dom';

// On charge tous les fichiers "Route" du projet
const publicModules = import.meta.glob([
	'./routes/public/*Route.ts',
	'./routes/public/*Route.tsx',
], { eager: true });

const publicRouter = createBrowserRouter([
	{
		children: [
			...Object.values(publicModules).flatMap((module: any) => module.default),
		],
	},
]);

export default function RouterProvider() {
	return <ReactRouterProvider router={publicRouter} />;
}
